import { useState, useEffect } from 'react';

export default function useMediaQuery(query: string): boolean {
  const supportMatchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  const [match, setMatch] = useState(
    supportMatchMedia && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (!supportMatchMedia) {
      setMatch(false);
      return;
    }

    const queryList = window.matchMedia(query);
    const updateMatch = () => {
      setMatch(queryList.matches);
    };

    setMatch(queryList.matches);

    if (queryList.addEventListener) {
      queryList.addEventListener('change', updateMatch);
    } else {
      queryList.addListener(updateMatch); // aware they are are deprecated, using for compatibility with older browsers
    }

    return () => {
      if (queryList.removeEventListener) {
        queryList.removeEventListener('change', updateMatch);
      } else {
        queryList.removeListener(updateMatch); // aware they are are deprecated, using for compatibility with older browsers
      }
    };
  }, [query, supportMatchMedia]);

  return match;
}
